import { render, staticRenderFns } from "./EditRuleset.vue?vue&type=template&id=524e07e9&scoped=true&"
import script from "./EditRuleset.vue?vue&type=script&lang=js&"
export * from "./EditRuleset.vue?vue&type=script&lang=js&"
import style0 from "./EditRuleset.vue?vue&type=style&index=0&id=524e07e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e07e9",
  null
  
)

export default component.exports